import { SearchQuery, Tag, Video } from './';

export class SearchResultItem {
  /**
   * An alphabetically-ordered list of the tags which this search result
   * matched.
   */
  public matchingTags: Array<Tag>;

  constructor(public video: Video, query: SearchQuery) {
    this.matchingTags = (video.tags || [])
      .filter(tag => query.tags.some(queryTag => queryTag.id === tag.id))
      .sort((tagA, tagB) => tagA.name.localeCompare(tagB.name));
  }
}

export class SearchResult {
  public results: Array<SearchResultItem>;

  constructor(videos: Array<Video>, query: SearchQuery) {
    this.results = videos.map(video => new SearchResultItem(video, query));
  }
}



// WEBPACK FOOTER //
// ./src/app/models/SearchResult.ts